import { Fragment } from 'react';
import { useHeroData } from '../hooks/useHeroData';
import { useIsOpenState } from '../hooks/useIsOpenState';
import { FindPartnerMatch } from './FindPartnerMatch';
import { HeroCarousel } from './HeroCarousel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Hero() {
  const {
    open,
    isOpen,
    close
  } = useIsOpenState();
  const {
    heroItems,
    loading,
    error
  } = useHeroData();
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(HeroCarousel, {
      heroItems: heroItems,
      onFindPartnerMatchClick: open
    }), isOpen && /*#__PURE__*/_jsx(FindPartnerMatch, {
      onClose: close
    })]
  });
}